import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { v1UserRepository } from '../data-access/repositories/V1UserRepository'

const base = ['v1-user']

export const v1UserQueries = {
  activeUsers: (params?: {
    limit?: number
    offset?: number
    search?: string
    sort?: string
  }) => ({
    queryKey: buildQueryKey([...base, 'active', params]),
    queryFn: () => v1UserRepository.listActiveUsers(params),
  }),
}
